import React, { useState } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import HamburgerIcon from './HamburgerIcon'
import NavMenu from './NavMenu'
// import CardReaderIndicator from '../containers/CardReaderIndicator'
import { ReactComponent as ConfirmVersionUpdateIcon } from '../assets/icons/yellow-exclamation.svg'
import ConfirmDialog from './dialog/ConfirmDialog'
import NetworkIndicator from '../containers/NetworkIndicator'
import PrintIndicator from '../containers/PrintIndicator'
import RevenueCenterTitle from '../containers/RevenueCenterTitle'
import CustomerSuiteTitle from '../containers/CustomerSuiteTitle'
import EventTitle from '../containers/EventTitle'
import { refreshCache, morningUpdate } from '../utils/newAppVersionAvailable'
import styles from './Navbar.module.scss'

const Navbar = ({ onMenuToggle, showEventHeader, showCustomerHeader, venueName, showMenu, updateAvailable, setAutomaticUpdate, automaticallyUpdate, className, tabMenu, userLoginScreen }) => {
  const [menuActive, setMenuActive] = useState(false)
  const [showConfirm, setShowConfirm] = useState(false)
  const classNames = cn(styles.navbar, className)
  const toggleMenuActive = showMenu ? showMenu : () => setMenuActive(!menuActive)
  const landscapeMode = document?.body?.clientWidth > 800
  let titleContent = venueName
  if (!venueName) {
    titleContent = landscapeMode || (!landscapeMode && !userLoginScreen) ? <RevenueCenterTitle className={styles.title} /> : null;
    if (showEventHeader) titleContent = <EventTitle className={styles.title} />
  }

  let confirmVersionUpdateComponent
  if (showConfirm) {
    confirmVersionUpdateComponent = (
    <ConfirmDialog
      title="Version update available"
      message={'Warning: Syncing may interrupt current orders in progress'}
      cancelButtonText="Try Later"
      confirmButtonText="Update Now"
      onCancel={() => {
        setShowConfirm(false)
        setAutomaticUpdate()
        morningUpdate()
      }}
      onConfirm={() => {
        refreshCache()
        setAutomaticUpdate()
      }}
    />
    )
  }

  return (
    <div className={classNames}>
      {menuActive && <NavMenu onToggle={toggleMenuActive} />}

      <div className={styles.contentLeft} >
        <button className={styles.iconContainer} onClick={toggleMenuActive}>
          <HamburgerIcon className={styles.hamburgerIcon} />
        </button>
        { updateAvailable && automaticallyUpdate && <div className={styles.versionUpdateIcon}>
          <ConfirmVersionUpdateIcon onClick={() => setShowConfirm(true)}/>
        </div> }
        <div className={styles.revenueCenterName}>
          {titleContent}
        </div>
      </div>

      {
        showCustomerHeader &&
        <div className={styles.contentCenter} >
          <div className={styles.customerSuiteName}>
            <CustomerSuiteTitle className={styles.title} />
          </div>
        </div>
      }

      <div className={styles.contentRight}>
        {/* <CardReaderIndicator className={styles.indicator} /> */}
        <PrintIndicator className={styles.indicator} />
        <NetworkIndicator className={styles.indicator} />
        
      </div>
      {confirmVersionUpdateComponent}
    </div>
  )
}

Navbar.defaultProps = {
  onMenuToggle: () => {},
  showEventHeader: false,
  showCustomerHeader: false
}

Navbar.propTypes = {
  onMenuToggle: PropTypes.func,
  showEventHeader: PropTypes.bool,
  showCustomerHeader: PropTypes.bool
}

export default Navbar
